import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import * as authApi from '../../api/auth';
import { getErrorMessage } from '../../utils/apiError';

export default function RedefinirSenha() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [verSenha, setVerSenha] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [concluido, setConcluido] = useState(false);
  const [erro, setErro] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    if (novaSenha !== confirmarSenha) {
      setErro('As senhas não coincidem.');
      return;
    }
    setEnviando(true);
    try {
      await authApi.redefinirSenha(token, novaSenha);
      setConcluido(true);
    } catch (err) {
      setErro(getErrorMessage(err, 'Link inválido ou expirado. Solicite um novo.'));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="sf-login">
      <div className="sf-login-brand">
        <div className="sf-login-lockup">
          <svg width="112" height="112" viewBox="0 0 64 64" fill="none" aria-hidden="true">
            <rect x="1" y="1" width="62" height="62" rx="18" fill="rgba(255,255,255,0.08)" stroke="rgba(255,255,255,0.18)" strokeWidth="1.5" />
            <rect x="15" y="17" width="34" height="9" rx="4.5" fill="#f4e389" />
            <rect x="15" y="29.5" width="24" height="9" rx="4.5" fill="#ffffff" opacity="0.92" />
            <rect x="15" y="42" width="34" height="9" rx="4.5" fill="#ffffff" opacity="0.55" />
          </svg>
          <span className="sf-login-lockup-name">StoreFlow</span>
        </div>
        <div className="sf-login-brand-footer">StoreFlow · DataFit</div>
      </div>

      <div className="sf-login-panel">
        <div className="sf-login-card">
          {!token ? (
            <>
              <h1>Link inválido</h1>
              <div className="sf-login-alert mb-3">
                <i className="bi bi-exclamation-circle" />
                Esse link de redefinição de senha está incompleto. Solicite um novo.
              </div>
              <Link to="/esqueci-senha" className="sf-login-submit" style={{ textDecoration: 'none' }}>
                Solicitar novo link
              </Link>
            </>
          ) : concluido ? (
            <>
              <h1>Senha redefinida</h1>
              <div
                className="sf-login-alert mb-3"
                style={{ background: 'var(--sf-primary-light)', borderColor: '#cfe0d0', color: 'var(--sf-primary-dark)' }}
              >
                <i className="bi bi-check-circle" />
                Sua senha foi atualizada. Já pode entrar com a nova senha.
              </div>
              <Link to="/login" className="sf-login-submit" style={{ textDecoration: 'none' }}>
                Ir para o login
                <i className="bi bi-arrow-right" />
              </Link>
            </>
          ) : (
            <>
              <h1>Redefinir senha</h1>
              <p style={{ margin: '-14px 0 20px', fontSize: 13.5, color: 'var(--sf-text-muted)' }}>
                Escolha uma nova senha para a sua conta.
              </p>

              <form className="sf-login-form" onSubmit={handleSubmit}>
                {erro && (
                  <div className="sf-login-alert">
                    <i className="bi bi-exclamation-circle" />
                    {erro}
                  </div>
                )}

                <label className="sf-field-label">
                  <span>Nova senha</span>
                  <span className="sf-field">
                    <i className="bi bi-lock" />
                    <input
                      type={verSenha ? 'text' : 'password'}
                      required
                      minLength={8}
                      autoFocus
                      value={novaSenha}
                      onChange={(e) => setNovaSenha(e.target.value)}
                    />
                    <button
                      type="button"
                      className="sf-field-toggle"
                      onClick={() => setVerSenha((v) => !v)}
                      aria-label={verSenha ? 'Ocultar senha' : 'Mostrar senha'}
                    >
                      <i className={verSenha ? 'bi bi-eye-slash' : 'bi bi-eye'} />
                    </button>
                  </span>
                </label>

                <label className="sf-field-label">
                  <span>Confirmar nova senha</span>
                  <span className="sf-field">
                    <i className="bi bi-lock" />
                    <input
                      type={verSenha ? 'text' : 'password'}
                      required
                      minLength={8}
                      value={confirmarSenha}
                      onChange={(e) => setConfirmarSenha(e.target.value)}
                    />
                  </span>
                </label>

                <p style={{ margin: 0, fontSize: 12.5, color: 'var(--sf-text-muted)' }}>Mínimo de 8 caracteres.</p>

                <button type="submit" className="sf-login-submit" disabled={enviando}>
                  {enviando ? 'Salvando...' : 'Redefinir senha'}
                  {!enviando && <i className="bi bi-arrow-right" />}
                </button>
              </form>

              <div className="sf-login-footnote" style={{ justifyContent: 'center' }}>
                <Link to="/login" className="sf-field-link">
                  <i className="bi bi-arrow-left me-1" />
                  Voltar para o login
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
